import React, { memo } from "react";
//img
import searchImg from "../../../assets/images/svg/Searchtech.svg";
//css
import classes from "./SearchBar.module.css";
import ImgFrame from "../ImageFrame/ImgFrame";

const SearchBar = ({
  onChange,
  value,
  customClass,
  placeholder = "Search",
  tooltip,
  onClear,
  clearTooltip = "Clear search",
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`${classes.search_wrapper} ${customClass} flex`}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        title={tooltip || placeholder}
        onChange={handleChange}
      />
      {value ? (
        <button
          type="button"
          className={classes.clearButton}
          onClick={onClear}
          aria-label={clearTooltip}
          title={clearTooltip}
        >
          ×
        </button>
      ) : null}
      <ImgFrame imgSrc={searchImg} imgSize={"2rem"} />
    </div>
  );
};

export default memo(SearchBar);
